import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Config from '../utils/Config';

export default function WebsitePreviewLaunch() {
  const { claimId } = useParams();
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const launch = async () => {
      try {
        const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
        if (!token) throw new Error('Authentication required');
        const response = await fetch(`${Config.API.API_BASE_URL}/api/dealers/preview/issue`, {
          method: 'POST', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ claimId }),
        });
        if (!response.ok) throw new Error('Preview unavailable');
        const data = await response.json();
        if (!/^[a-f\d]{64}$/.test(data.code)) throw new Error('Preview unavailable');
        const destination = new URL(data.micrositeOrigin);
        if (!['http:', 'https:'].includes(destination.protocol)) throw new Error('Preview unavailable');
        destination.hash = `preview-code=${data.code}`;
        window.location.replace(destination.href);
      } catch {
        toast.error('Website preview unavailable. Please return to your dealership and try again.');
      }
    };
    launch();
  }, [claimId]);
  return null;
}
